module.exports = "//public.zight.com/packs/media/images/view-list-186daea1c0dfd0f237dd8e0c3075e007.svg";